<script lang="ts" setup>
import { ref } from 'vue';
import { EmployeeRole } from '@posx/core';
import { useEmployeeRoleStore } from '@/stores/employee.role';
import { logError, serializeError } from '@/utils/logger';

const $props = defineProps<{
  modelValue?: string;
  multiple?: boolean;
  type?: string;
  disabled?: boolean;
  defaultRoleName?: string;
}>();
const $emit = defineEmits(['change', 'update:value', 'update:modelValue']);

const employeeRole = useEmployeeRoleStore();
const list = ref<EmployeeRole[]>([]);

const value = ref($props.modelValue);

employeeRole.getList().then((data) => {
  if (data) {
    list.value = data;
    // Set default role by name if no modelValue is provided
    if (!value.value && $props.defaultRoleName) {
      const defaultRole = data.find(role => role.name === $props.defaultRoleName);
      if (defaultRole) {
        value.value = defaultRole.uid;
        $emit('update:modelValue', defaultRole.uid);
      }
    }
  }
}).catch((err) => logError('Failed to fetch employee roles', serializeError(err)));
const handleChange = () => {
  console.log(value.value);
  $emit('change', value.value);
  $emit('update:modelValue', value.value);
  $emit('update:value', value.value);
};
</script>

<template>
  <el-select v-model="value" @change="handleChange" :multiple="$props.multiple" :disabled="$props?.disabled">
    <el-option v-for="item in list" :key="item.uid" :label="item.name" :value="item.uid"></el-option>
  </el-select>
</template>
